import { app } from "@/environment";
import { SESSION_PRIMARY_TENANT } from "./auth-config";
import { getUniversesWithAuthentication } from "./universes-with-authentication";

const isProduction = app.environment === "production";

export function getAuthTenantSettings(universeTag: string | null) {
  const universesWithAuthentication = getUniversesWithAuthentication();

  if (!universeTag) return {};

  const universe = universesWithAuthentication.find(
    ({ tag }) => tag === universeTag,
  );

  if (!universe) return {};

  if (isProduction && universe.url !== SESSION_PRIMARY_TENANT) {
    const domain = new URL(universe.url).host;
    return {
      isSatellite: true,
      signInUrl: `${SESSION_PRIMARY_TENANT}/logg-inn`,
      signUpUrl: `${SESSION_PRIMARY_TENANT}/logg-inn`,
      domain,
      satelliteAutoSync: false, // Default is false, but keep this explicit because setting it to true breaks page indexing.
    } as const;
  }

  if (isProduction && universe.url === SESSION_PRIMARY_TENANT) {
    return {
      allowedRedirectOrigins: universesWithAuthentication
        .filter(({ url }) => url !== universe.url)
        .map(({ url }) => url),
    } as const;
  }

  return {};
}
